import React from "react";
import PropTypes from "prop-types";
import { Card } from "primereact/card";
import { Button } from "primereact/button";

/**
 * Einheitliche Vollbild-Ansicht für fehlende Berechtigung (z. B. 403),
 * fehlgeschlagene Rollen-Ladung oder ähnliche Zugriffssperren.
 *
 * @example
 * <AccessBlockedView
 *   title="Zugriff verweigert"
 *   code="403"
 *   summary={<>Nur für <strong>Admin</strong>.</>}
 *   footer={<p className="text-muted small">Rolle: {role}</p>}
 *   iconClassName="pi pi-lock text-muted"
 *   actions={[
 *     { label: "Zurück", onClick: () => navigate(-1), className: "btn btn-outline-secondary me-2" },
 *     { label: "Zur Übersicht", onClick: () => navigate("/uebersicht"), className: "btn btn-primary" },
 *   ]}
 * />
 */
const AccessBlockedView = ({
  pageClassName,
  cardClassName,
  contentClassName,
  topSlot,
  iconClassName,
  title,
  code,
  summary,
  footer,
  actions,
}) => {
  return (
    <div className={pageClassName}>
      <Card className={cardClassName}>
        {topSlot}
        <div
          className={`access-blocked-view text-center py-5 px-3 ${contentClassName}`.trim()}
        >
          {iconClassName ? (
            <i
              className={iconClassName}
              style={{ fontSize: "3rem" }}
              aria-hidden
            />
          ) : null}
          <h3 className="mt-3 mb-2">{title}</h3>
          {code ? (
            <p className="text-muted mb-1">
              <span className="fw-semibold">{code}</span>
              {summary != null && summary !== "" ? " — " : ""}
              {summary}
            </p>
          ) : summary ? (
            <p className="text-muted mb-4">{summary}</p>
          ) : null}
          {footer}
          {actions?.length > 0 ? (
            <div className="mt-3">
              {actions.map(({ label, onClick, className, type = "button" }, i) => (
                <Button
                  key={`${label}-${i}`}
                  type={type}
                  className={className || "btn btn-primary"}
                  onClick={onClick}
                >
                  {label}
                </Button>
              ))}
            </div>
          ) : null}
        </div>
      </Card>
    </div>
  );
};

AccessBlockedView.propTypes = {
  pageClassName: PropTypes.string,
  cardClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  topSlot: PropTypes.node,
  iconClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  code: PropTypes.string,
  summary: PropTypes.node,
  footer: PropTypes.node,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      className: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
};

AccessBlockedView.defaultProps = {
  pageClassName: "page-container",
  cardClassName: "default-padding-card",
  contentClassName: "",
  topSlot: null,
  iconClassName: undefined,
  code: undefined,
  summary: undefined,
  footer: null,
  actions: [],
};

export default AccessBlockedView;
